import React from "react";
import { FormSection, FormFieldGroup } from "component-library/formSections";
import * as Fields from "./../FieldNames";
import IncludedInPayroll from "../active/IncludedInPayroll";
const InactiveDetails = ({ onChange, data = {} }) => {
  return (
    <FormSection title={"Inactivation Details"} hr>
      <FormFieldGroup
        inputType="singleDatePicker"
        label="Inactivation Date"
        fieldType="inline"
        inputName={Fields.inactivationDate}
        value={data[Fields.inactivationDate]}
        colSpan="col-lg-3 col-md-3"
        Size={[4, 4, 12, 12]}
        onChange={onChange}
        style={{ marginBottom: "15px" }}
        getToFromValue={onChange}
      />
      <IncludedInPayroll
        label="Should this employee be included in payroll?"
        colSpan="col-lg-3 col-md-3"
        inputName={Fields.inactivationIncludedInPayroll}
        data={data}
        value={data[Fields.inactivationIncludedInPayroll]}
        onChange={onChange}
        middleText="Until which paycheck date"
      />
      <FormFieldGroup
        inputType="textarea"
        inputName={Fields.inactivationNotes}
        label="Notes"
        value={data[Fields.inactivationNotes]}
        fieldType="inline"
        description="250 characters max"
        rows={6}
        colSpan="col-lg-3 col-md-3"
        Size={[8, 8, 12, 12]}
        onChange={onChange}
        getToFromValue={onChange}
        optional
      />
    </FormSection>
  );
};

export default InactiveDetails;
